import Container = PIXI.Container;
import { Back, TweenLite } from 'gsap';
import { GameAudio } from '../../../Config/Audio';
import { getGameSize } from '../../../Config/Levels';
import { gameConfig } from '../../../index';
import { HudActions, HudEmitter } from '../../../Managers/Hud/HudEmitter';
import { Popup } from '../../../Managers/Popups';
import { PurchaseStatus } from '../../../SDK/ISDKpayments';
import SoundManager from '../../../Sound/SoundManager';
import { createPixiText } from '../../../Utils/Utils';
import Sprite = PIXI.Sprite;
import { UIButton } from '../../Shared/Buttons/UIButton';
import { ScreenBlur } from '../../Shared/ScreenBlur';
import { ITweenable } from '../ITweenable';
import Core from '../../../Core/Core';

export class PurchaseStatusPopup extends Container implements ITweenable {
    private readonly popupContainer: Container;
    constructor(status: PurchaseStatus) {
        super();
        this.popupContainer = new Container();
        const bgWidth = gameConfig.game_width * 0.9;
        const bgHeigth = gameConfig.game_height * 0.65;
        const bgtexture = PIXI.utils.TextureCache['commonui/popup-bg'];
        const bg = new PIXI.mesh.NineSlicePlane(bgtexture, 100, 100, 100, 100);
        bg.width = bgWidth;
        bg.height = bgHeigth;
        bg.interactive = true;

        const txtDisplay = createPixiText(
            Core.local.getText(`purchase${PurchaseStatus[status]}`),
            new PIXI.Rectangle(bgWidth * 0.5, bgHeigth * 0.12, bgWidth * 0.7, bgHeigth * 0.3),
            'Baloo',
            35,
            28,
            0x006eba
        );
        txtDisplay.anchor.set(0.5);

        const icon = new Sprite(PIXI.utils.TextureCache['character/character-lose']);
        // icon.scale.set(2);
        icon.anchor.set(0.5);
        icon.x = bgWidth * 0.5;
        icon.y = bg.y + bg.height * 0.4;
        txtDisplay.x = icon.x;
        txtDisplay.y = icon.y + icon.height / 2;

        const closeBtn = new UIButton('commonui/button-close');
        closeBtn.x = bgWidth - closeBtn.width / 2;
        closeBtn.y = closeBtn.height / 2;
        closeBtn.once('trigger', () =>
            HudEmitter.instance.emit(HudActions.CLOSE_POPUP, Popup.PURCHASE_STATUS, -1)
        );

        const blur = new ScreenBlur();
        //@ts-ignore
        this.popupContainer.addChild(bg, txtDisplay, icon, closeBtn);
        this.addChild(blur, this.popupContainer);
        const { gameWidth, gameHeight } = getGameSize();
        this.popupContainer.x = gameWidth / 2 - bgWidth / 2;
        this.popupContainer.y = gameHeight + bgHeigth / 2;
    }

    public tweenIn(): void {
        SoundManager.playSound(GameAudio.WHOOSH_IN);
        const { yOffset } = getGameSize();
        TweenLite.to(this.popupContainer, 0.7, {
            ease: Back.easeOut.config(2),
            y: yOffset + gameConfig.game_height * 0.2,
        });
    }

    public tweenOut(): any {
        SoundManager.playSound(GameAudio.WHOOSH_OUT);
        TweenLite.to(this.popupContainer, 0.7, {
            ease: Back.easeIn.config(2),
            onComplete: () => {
                this.destroy();
            },
            y: getGameSize().gameHeight + 500,
        });
    }
}
